import gsap from 'gsap';

import 'gsap/src/uncompressed/plugins/DrawSVGPlugin';

import BezierEasing from 'bezier-easing';

import PxLoader from 'pxloader';

import PxLoaderImage from 'pxloader/PxLoaderImage';

import Component from '../base/component';

import { qs, qsa, toggleClass } from '../base/dom-utils';

class Loader extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.handleProgress = this.handleProgress.bind(this);
        this.animateEnterSprite = this.animateEnterSprite.bind(this);
        this.animateExitSprite = this.animateExitSprite.bind(this);

        this.$els.sprite = qs(this.options.sprite, this.$el);
        this.$els.rect = qs('rect', this.$els.sprite);
        this.$els.circle = qs('path', this.$els.sprite);
        this.$els.lines = qsa('line', this.$els.sprite);

        this.$els.bar = qs(this.options.bar, this.$el);
        this.$els.progress = qs(this.options.progress, this.$el);
        this.$els.bars = [this.$els.bar, this.$els.progress];

        gsap.set(qsa('rect, path, line', this.$els.sprite), {
            opacity: 0
        });

        this._totalImages = global.__MANIFEST.length;

        this._px = new PxLoader();

        global.__MANIFEST.forEach((image) => this._px.add(new PxLoaderImage(image)));
    }

    beforeInit() {

        toggleClass(this.$el, 'is-loading', true);

        toggleClass(document.body, 'is-loader-open', true);

        this._px.start();

        this._px.addProgressListener(this.handleProgress);
    }

    init() {

        super.init();

        const p1 = this.animateEnterSprite();

        const p2 = new Promise((resolve, reject) => {
            this._px.addCompletionListener(resolve);
        });

        return Promise.all([p1, p2]).then(() => this.animateExitSprite());
    }

    handleProgress(e) {

        console.warn('image loading image nr ' + e.completedCount);

        gsap.set(this.$els.bar, {
            width: (e.completedCount / this._totalImages) * 100 + '%'
        });

        if (e.error) {
            console.warn('error loading image nr ' + e.completedCount);
        }
    }

    animateEnterSprite() {

        return new Promise((resolve, reject) => {

            const tl = new TimelineMax({
                onComplete: () => resolve()
            });

            const loaderEase = BezierEasing(0.94, 0.13, 0.34, 0.99);

            tl.fromTo(this.$els.rect, 1.2, {
                opacity: 1,
                drawSVG: '100% 100%'
            }, {
                drawSVG: '100%',
                ease: new Ease(loaderEase)
            })

            .fromTo(this.$els.circle, 1.2, {
                opacity: 1,
                drawSVG: '0% 0%'
            }, {
                drawSVG: '100%',
                ease: new Ease(loaderEase)
            }, '-=1.1')

            .staggerFromTo(this.$els.lines, 0.3, {
                opacity: 1,
                drawSVG: '0% 0%'
            }, {
                drawSVG: '100%',
                // ease: Sine.easeInOut
            }, 0.1, '-=0.4')

            // .to(this.$els.rect, 0.2, {
            //     transformOrigin: '50% 50%',
            //     scale: 1.05,
            //     ease: Power1.easeOut
            // }, '-=0.2')

            .to(this.$els.rect, 0.2, {
                scale: 1,
                ease: Power1.easeOut
            })

            // .to(this.$els.circle, 0.2, {
            //     transformOrigin: '50% 50%',
            //     scale: 1.05,
            //     ease: Power1.easeOut
            // }, '-=0.2')

            .to(this.$els.circle, 0.2, {
                scale: 1,
                ease: Power1.easeOut
            });

            gsap.to(this.$els.progress, 1, {
                transformOrigin: '0% 100%',
                scaleX: 1,
                ease: new Ease(loaderEase)
            });

        });

    }

    animateExitSprite() {

        return new Promise((resolve, reject) => {

            const tl = new TimelineMax({

                onComplete: () => {
                    toggleClass(this.$el, 'is-loading', false);
                    toggleClass(this.$el, 'is-loaded', false);
                    resolve();
                },

                onStart: () => toggleClass(document.body, 'is-loader-open', false)

            });

            const loaderEase = BezierEasing(0.94, 0.13, 0.34, 0.99);

            tl.to(this.$els.circle, 0.7, {
                delay: 1,
                drawSVG: '0%',
                ease: new Ease(loaderEase)
            })

            .to(this.$els.rect, 0.7, {
                drawSVG: '0%',
                ease: new Ease(loaderEase)
            }, '-=0.6')

            .staggerTo(this.$els.lines, 0.4, {
                drawSVG: '0%'
            }, 0.1, '-=0.7')

            .staggerTo(this.$els.bars, 0.8, {
                transformOrigin: '100% 0%',
                scaleX: 0
            }, 0.1, '-=0.2')

            .to(this.$el, 0.4, {
                //scale: 0.85,
                autoAlpha: 0
            });

        });

    }

    getDefaultOptions() {
        return {
            sprite: '#loader-sprite',
            bar: '.c-loader__bar',
            progress: '.c-loader__progress'
        }
    }
}

export default Loader;


/** WEBPACK FOOTER **
 ** ./components/loader.js
 **/